<template>
    <div class="yun-header-userpanel">
        <el-popover width="200" placement="bottom-end" :visible-arrow="false" popper-class="user-panel-popover" trigger="click">
            <div class="user-panel-popover-title">
                <div class="account-block">
                    <p class="nickname nowrap" :title="name">
                        {{name}}
                    </p>
                    <p class="account nowrap" :title="email">{{email}}</p>
                </div>
            </div>
            <div class="user-panel-popover-content">
                <ul>
                    <li>
                        <a href="https://account.wps.com/usercenter/apps" target="_blank" v-cloak :title="$t('Ucenter')">{{$t('Ucenter')}}</a>
                    </li>
                    <li>
                        <a href="https://drive.wps.com?zeus=1" v-cloak :title="$t('Oldversion')">{{$t('Oldversion')}}</a>
                    </li>
                    <li class="divided" @click="feedback" v-cloak :title="$t('Feedback')" v-t="'Feedback'"></li>
                    <li v-cloak @click="logout" :title="$t('Exit')">{{$t('Exit')}}</li>
                </ul>
            </div>
            <img slot="reference" :src="avatar" class="yun-header-avatar"/>
        </el-popover>
    </div>
</template>

<script>
import {mapState,mapActions, mapMutations} from 'vuex'
export default {
    computed:{
        ...mapState('user',[
            'name',
            'email',
            'avatar'
        ])
    },
    methods:{
        ...mapActions([
            'logout'
        ]),
        ...mapMutations([
            'SHOW_DIALOG'
        ]),
        feedback(){
            _dw.onEvent('drive_feedback')
            this.SHOW_DIALOG({
				title: this.$t('Feedback'),
				current: 'Feedback',
				size: 'large'
			})
        }
    }
}
</script>

<style>
.yun-header-userpanel{
    position: absolute;
    right: 0;
    cursor: pointer;
    top: 24px;
    margin-right: 20px;
}
.user-panel-popover{
    padding: 0!important;
}
.yun-header-avatar{
    height: 28px;
    width: 28px;
    border-radius: 50%;
}
.user-panel-popover-title{
    padding: 4px 14px;
    border-bottom: 1px solid #f3f6f9;
}
.user-panel-popover-title .nickname{
    height: 34px;
    line-height: 40px;
    color:#3c414b;
}
.user-panel-popover-title .account{
    color: #949aae;
    margin: 0 auto;
    height: 20px;
    line-height: 13px;
    font-size: 13px;
}
.yun-user-panel-content{
    font-size: 12px;
    border-top: 1px solid #f3f6f9;
}
.user-panel-popover-content ul{
    padding: 4px;
}
.user-panel-popover-content li{
    padding: 0 10px;
    height: 30px;
    line-height: 30px;
    cursor: pointer;
    font-size: 12px;
    color: #626b84;
}
.user-panel-popover-content li a{
    color: #626b84;
    display: block;
    text-decoration: none;
}
.user-panel-popover-content li:hover{
    background: #fafcff;
}
.user-panel-popover-content .divided{
    border-top: 1px solid #f3f6f9;
}
</style>


// WEBPACK FOOTER //
// src/components/Avatar.vue